import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage, FormattedHTMLMessage, injectIntl, intlShape } from 'react-intl';
import '../TermsPage.less';
import CancelUrl, {COMPONENT_STYLE} from '../../../../components/CancelUrl/CancelUrl';
import Button, {BUTTON_STYLE} from '../../../../../shared-components/Button/Button';
import DynamicIframe from '../../../../../shared-components/DynamicIframe/DynamicIframe';
import PopupLink from '../../../../../shared-components/PopupLink/PopupLink';
import StickyFooter from '../../../../../shared-components/StickyFooter/StickyFooter';
import Waypoint from 'react-waypoint';
import {Field, reduxForm, Form, submit} from 'redux-form';
import _ from 'lodash';
import PropTypes from 'prop-types';
import CheckBox from '../../../../../shared-components/CheckBox/CheckBox';
import {isEmpty} from '../../../../../shared-components/FormElement/FormElementUtils';
import {CONTRACT_FORM_ID} from '../../../../../framework/App/AppConstants';
import {submitContractApi} from './TermsPageFormActions';
import { scrollToBottom } from '../../../../../GB/components/AgreementCheckbox/AgreementCheckboxUtils';
import { trackTransition } from '../../../../../framework/store/FPTI/FPTIActions';
import { ROUTES_DE } from '../../../../../../../server/src/controllers/DE/routesDEConstants';

const LOCALE_PREFIX = 'DE/pages/TermsPage/TermsPage';
const REPAYMENT_LOCALE_PREFIX = 'DE/pages/RepaymentPage/RepaymentPage';

export class TermsPageForm extends Component {
    static propTypes = {
        htmlContract: PropTypes.string.isRequired,
        intl: intlShape.isRequired,
        formValues: PropTypes.object,
        handleSubmit :PropTypes.func.isRequired,
        onClickContinue: PropTypes.func.isRequired,
        onFormSubmit: PropTypes.func.isRequired,
    };

    constructor() {
        super();
        this.state = {
            fixToBottom: true,
            showButtons: false,
        };
    }

    componentDidUpdate(prevProps, prevState) {
        const checkedPath = 'formValues.agreeToReadContract';
        const oldChecked = _.get(prevProps, checkedPath, false);
        const newChecked = _.get(this.props, checkedPath, false);
        if (oldChecked !== newChecked && newChecked === true) {
            this.setState({
                showButtons: true,
            });
            scrollToBottom(window, 1000);
        }

        if (prevState.fixToBottom === true && this.state.fixToBottom === false) {
            this.setState({
                showButtons: true,
            });
        }
    }

    onFormSubmit = (formValues) => {
        const { onFormSubmit, intl } = this.props;
        return onFormSubmit(formValues, intl);
    };

    handleWaypointEnter = () => {
        this.setState({ fixToBottom: false });
    };

    handleWaypointLeave = () => {
        this.setState({ fixToBottom: true });
    };

    showTermsPrintPopup = () => {
        const termsWindow = window.open('about:blank', 'CreditContract', 'width=835, height=500, location=1, status=1, toolbar=0, menubar=0, resizable=1, scrollbars=1');
        termsWindow.focus();
        termsWindow.document.write(`<!DOCTYPE html>${this.props.htmlContract}`);
        termsWindow.print();
    };

    showTermsDownloadPopup = () => {
        window.open(ROUTES_DE.creditContractFromSession, 'CreditContract', 'width=835, height=500, location=1, status=1, toolbar=0, menubar=0, resizable=1, scrollbars=1');
    };

    render() {
        const { htmlContract, intl, handleSubmit, onClickContinue} = this.props;
        const { fixToBottom, showButtons } = this.state;
        const contractAgreeLabel = (
            <div>
                <FormattedHTMLMessage
                    id={`${LOCALE_PREFIX}.readAndAgree`}
                />
            </div>
        );

        return (
            <Form
                id="TermPageForm"
                onSubmit={handleSubmit(this.onFormSubmit)}
            >
                {/*Print and Download button*/}
                <div id="creditContractPrint" className="print-clearfix">
                    <p className="print-content">
                        <span className="print-icon" />
                        <a href="#"
                            data-automation-id="print"
                            className="print-html-link"
                            name="print-html-link"
                            onClick={this.showTermsPrintPopup}
                        >
                            {intl.formatMessage({ id: `${LOCALE_PREFIX}.printCopy` })}
                        </a>
                    </p>
                    <p className="print-content">
                        <span className="download-icon" />
                        <a href="#"
                            data-automation-id="download"
                            className="print-html-link"
                            name="downloadd-html-link"
                            onClick={this.showTermsDownloadPopup}
                        >
                            <FormattedMessage
                                id={`${LOCALE_PREFIX}.contractPDF`}
                            />
                        </a>
                    </p>
                </div>
                <hr className="vx_hr" />

                {/*Contract html*/}
                <div>
                    <div className="outline-frame" >
                        <div className="contract-fade" />
                        <div className="outline-body" >
                            <DynamicIframe
                                htmlString={htmlContract}
                                autoHeight={true}
                                extraHeight={80}
                                scrolling={'no'}
                                className="credit-contract-iframe"
                                id="termpage-iframe"
                            />
                        </div>
                    </div>
                </div>


                {/*Agree Checkbox and button*/}
                <StickyFooter fixToBottom={fixToBottom} fadedBackground={true}>
                    <div className="agree-credit">
                        <Field
                            id="agreeToReadContract"
                            name="agreeToReadContract"
                            label={contractAgreeLabel}
                            component={CheckBox}
                            validate={isEmpty(intl.formatMessage({id: `${LOCALE_PREFIX}.agreeContractError`}))}
                        />
                    </div>
                    {showButtons &&
                    <div className="buttons">
                        <div id="action-buttons" className="vx_btn-group">
                            <Button
                                data-automation-id="confirmAndApply"
                                btnStyle={BUTTON_STYLE.PP_PRIMARY}
                                id="confirmAndApplyBtn"
                                onClick={onClickContinue}
                            >
                                <FormattedMessage
                                    id={`${LOCALE_PREFIX}.acceptAndContinue`}
                                />
                            </Button>
                            <CancelUrl
                                componentType={COMPONENT_STYLE.LINK_BUTTON}
                                fptiEvent={{
                                    stateName: 'pp_credit_termspage',
                                    transitionName: 'cancel_pp_credit_termspage'
                                }}
                                customLabel={`${REPAYMENT_LOCALE_PREFIX}.cancelApplication`}
                            />
                        </div>
                    </div>}
                </StickyFooter>
                <Waypoint
                    onEnter={this.handleWaypointEnter}
                    onLeave={this.handleWaypointLeave}
                />

            </Form>
        );
    }
}

export const mapStateToProps = state => ({
    htmlContract: _.get(state, 'serverData.decisionModel.htmlContract', ''),
    formValues: _.get(state, `form.${CONTRACT_FORM_ID}.values`)
});


export const mapDispatchToProps = dispatch => {
    return {
        onClickContinue: (event) => {
            dispatch(submit(CONTRACT_FORM_ID));
        },
        onFormSubmit: (formValues, intl) => {
            dispatch(trackTransition('ppc_credit_agreement', 'process_ppc_credit_agreement'));
            return dispatch(submitContractApi(formValues, LOCALE_PREFIX, intl));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(
    reduxForm({
        form: CONTRACT_FORM_ID,
        destroyOnUnmount: false,
        forceUnregisteredOnUnmount: true
    })(TermsPageForm)
));
